import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import GetCategoriesQuery from '../Query/Categories';
import CategoriesTree from './CategoriesTree';
import CountryService from '../../services/CountryService';

import './style.scss';

interface ICategoriesProps extends RouteComponentProps<{ language: string }> {
  selected?: string;
}

class Categories extends React.Component<ICategoriesProps> {

  public render() {
    return (
      <GetCategoriesQuery>
        {({ categories }: any) => {
          if (categories && categories.categories) {

            // najdu všechny vybrané kategorie ve stromě
            const selectedCategories = this.getSelectedWithParents(categories.categories);

            return (
              <div className="categories">
                <CategoriesTree
                  selected={selectedCategories}
                  categories={categories.categories} 
                />
              </div>
            );
          }

          return null;
        }}
      </GetCategoriesQuery>
    );
  }

  private getSelectedWithParents(categories: Array<GQL.ICategory>) {
    const { selected } = this.props;
    const language = CountryService.GetInstance().language;

    const output: string[] = [];

    if (!selected) {
      return output;
    }

    const selectedCategory = categories.find((category: GQL.ICategory) => category.slug[language] === selected);
    if (selectedCategory) {
      output.push(selectedCategory.id);

      for (let i = 0; i < 5; i++) {
        output.forEach((categoryId: string) => {
          const category = categories.find((cat: GQL.ICategory) => cat.id === categoryId);
          if (category && category.parentCategoryId && !(output as any).includes(category.parentCategoryId)) {
            output.push(category.parentCategoryId);
          }
        });
      }
    }

    return output;
  }
}

export default withRouter(Categories);



// WEBPACK FOOTER //
// ./src/components/Categories/Categories.tsx